
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const PRF = () => {
  const treatmentData = {
    title: "PRF Treatment",
    subtitle: "Platelet-rich fibrin for natural skin rejuvenation",
    description: "PRF uses your body's own healing factors to stimulate collagen production and skin renewal. This natural treatment provides long-lasting results with minimal downtime.",
    whoItsFor: [
      "Those wanting natural skin rejuvenation",
      "People with fine lines and wrinkles",
      "Anyone seeking improved skin texture",
      "Clients with acne scars",
      "Those preferring natural treatments"
    ],
    packages: [
      {
        name: "PRF Facial",
        visitorPrice: "$550",
        memberPrice: "$495",
        description: "Full face PRF treatment with microneedling"
      },
      {
        name: "PRF Under Eyes",
        visitorPrice: "$450",
        memberPrice: "$405",
        description: "Targeted treatment for under-eye rejuvenation"
      },
      {
        name: "PRF Series",
        visitorPrice: "$1,450",
        memberPrice: "$1,305",
        description: "Package of 3 treatments for optimal results"
      }
    ],
    beforeCare: [
      "Stay well hydrated",
      "Eat a good meal before treatment",
      "Avoid alcohol 24 hours prior",
      "No blood thinners for 1 week"
    ],
    duringCare: [
      "Small blood draw to create PRF",
      "Topical numbing for comfort",
      "Precise injection or microneedling application",
      "60-75 minute total treatment time"
    ],
    afterCare: [
      "Gentle skincare for 24 hours",
      "Avoid strenuous exercise for 24 hours",
      "Apply ice if swelling occurs",
      "Results develop over 2-3 months"
    ],
    memberPerks: [
      "10% discount on all PRF treatments",
      "Complimentary consultation to determine best approach",
      "Free post-treatment follow-up",
      "Priority booking for series packages",
      "Access to natural healing enhancement products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default PRF;
